/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ coach: NonNullable<unknown> }} Features_Day_SessionInputs */

const en_features_day_session = /** @type {(inputs: Features_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1:1 session · ${i?.coach}`)
};

const pl_features_day_session = /** @type {(inputs: Features_Day_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trening 1:1 · ${i?.coach}`)
};

/**
* | output |
* | --- |
* | "1:1 session · {coach}" |
*
* @param {Features_Day_SessionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_session = /** @type {((inputs: Features_Day_SessionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_SessionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_session(inputs)
	return en_features_day_session(inputs)
});